import { api } from './client';

export const workflowApi = {
  // === 인사 발령 (BACK-060) ===
  getPersonnelOrderTypes: async (): Promise<any> => {
    const response = await api.get('/api/personnel-orders/types');
    return response.data;
  },

  getPersonnelOrderStatuses: async (): Promise<any> => {
    const response = await api.get('/api/personnel-orders/statuses');
    return response.data;
  },

  getPersonnelOrderDashboard: async (): Promise<any> => {
    const response = await api.get('/api/personnel-orders/dashboard');
    return response.data;
  },

  getPersonnelOrdersPending: async (): Promise<any> => {
    const response = await api.get('/api/personnel-orders/pending');
    return response.data;
  },

  getPersonnelOrders: async (params?: any): Promise<any> => {
    const response = await api.get('/api/personnel-orders/', { params });
    return response.data;
  },

  createPersonnelOrder: async (data: any): Promise<any> => {
    const response = await api.post('/api/personnel-orders/', data);
    return response.data;
  },

  getPersonnelOrder: async (orderId: number): Promise<any> => {
    const response = await api.get(`/api/personnel-orders/${orderId}`);
    return response.data;
  },

  updatePersonnelOrder: async (orderId: number, data: any): Promise<any> => {
    const response = await api.patch(`/api/personnel-orders/${orderId}`, data);
    return response.data;
  },

  addPersonnelOrderItem: async (orderId: number, data: any): Promise<any> => {
    const response = await api.post(`/api/personnel-orders/${orderId}/items`, data);
    return response.data;
  },

  removePersonnelOrderItem: async (orderId: number, itemId: number): Promise<any> => {
    const response = await api.delete(`/api/personnel-orders/${orderId}/items/${itemId}`);
    return response.data;
  },

  submitPersonnelOrder: async (orderId: number): Promise<any> => {
    const response = await api.post(`/api/personnel-orders/${orderId}/submit`);
    return response.data;
  },

  approvePersonnelOrder: async (orderId: number, comment?: string): Promise<any> => {
    const response = await api.post(`/api/personnel-orders/${orderId}/approve`, { comment });
    return response.data;
  },

  rejectPersonnelOrder: async (orderId: number, comment: string): Promise<any> => {
    const response = await api.post(`/api/personnel-orders/${orderId}/reject`, { comment });
    return response.data;
  },

  cancelPersonnelOrder: async (orderId: number): Promise<any> => {
    const response = await api.post(`/api/personnel-orders/${orderId}/cancel`);
    return response.data;
  },

  revertPersonnelOrder: async (orderId: number): Promise<any> => {
    const response = await api.post(`/api/personnel-orders/${orderId}/revert`);
    return response.data;
  },

  executePersonnelOrder: async (orderId: number): Promise<any> => {
    const response = await api.post(`/api/personnel-orders/${orderId}/execute`);
    return response.data;
  },

  getEmployeeOrderHistory: async (employeeId: string): Promise<any> => {
    const response = await api.get(`/api/personnel-orders/employee/${encodeURIComponent(employeeId)}/history`);
    return response.data;
  },

  // === 결재 워크플로우 (BACK-059) ===
  getWorkflowTypes: async (): Promise<any> => {
    const response = await api.get('/api/workflow/types');
    return response.data;
  },

  getWorkflowStatuses: async (): Promise<any> => {
    const response = await api.get('/api/workflow/statuses');
    return response.data;
  },

  getWorkflowDashboard: async (): Promise<any> => {
    const response = await api.get('/api/workflow/dashboard');
    return response.data;
  },

  getWorkflowBadge: async (): Promise<any> => {
    const response = await api.get('/api/workflow/badge');
    return response.data;
  },

  getRecentWorkflows: async (limit: number = 10): Promise<any> => {
    const response = await api.get('/api/workflow/recent', { params: { limit } });
    return response.data;
  },

  getWorkflowPending: async (): Promise<any> => {
    const response = await api.get('/api/workflow/pending');
    return response.data;
  },

  getWorkflowMyRequests: async (status?: string): Promise<any> => {
    const response = await api.get('/api/workflow/my-requests', { params: status ? { status } : {} });
    return response.data;
  },

  getWorkflowInstances: async (params?: any): Promise<any> => {
    const response = await api.get('/api/workflow/instances', { params });
    return response.data;
  },

  createWorkflowInstance: async (data: any): Promise<any> => {
    const response = await api.post('/api/workflow/instances', data);
    return response.data;
  },

  getWorkflowInstance: async (instanceId: number): Promise<any> => {
    const response = await api.get(`/api/workflow/instances/${instanceId}`);
    return response.data;
  },

  submitWorkflow: async (instanceId: number): Promise<any> => {
    const response = await api.post(`/api/workflow/instances/${instanceId}/submit`);
    return response.data;
  },

  approveWorkflow: async (instanceId: number, comment?: string): Promise<any> => {
    const response = await api.post(`/api/workflow/instances/${instanceId}/approve`, { comment });
    return response.data;
  },

  rejectWorkflow: async (instanceId: number, comment: string): Promise<any> => {
    const response = await api.post(`/api/workflow/instances/${instanceId}/reject`, { comment });
    return response.data;
  },

  delegateWorkflow: async (instanceId: number, delegatedTo: string, delegatedName: string, comment?: string): Promise<any> => {
    const response = await api.post(`/api/workflow/instances/${instanceId}/delegate`, { delegated_to: delegatedTo, delegated_name: delegatedName, comment });
    return response.data;
  },

  withdrawWorkflow: async (instanceId: number, reason?: string): Promise<any> => {
    const response = await api.post(`/api/workflow/instances/${instanceId}/withdraw`, { reason });
    return response.data;
  },

  cancelWorkflow: async (instanceId: number): Promise<any> => {
    const response = await api.post(`/api/workflow/instances/${instanceId}/cancel`);
    return response.data;
  },

  deleteWorkflowInstance: async (instanceId: number): Promise<any> => {
    const response = await api.delete(`/api/workflow/instances/${instanceId}`);
    return response.data;
  },

  addWorkflowStep: async (instanceId: number, data: any): Promise<any> => {
    const response = await api.post(`/api/workflow/instances/${instanceId}/steps`, data);
    return response.data;
  },

  removeWorkflowStep: async (instanceId: number, approvalId: number): Promise<any> => {
    const response = await api.delete(`/api/workflow/instances/${instanceId}/steps/${approvalId}`);
    return response.data;
  },

  replaceWorkflowApprover: async (instanceId: number, approvalId: number, newApproverId: string, newApproverName: string): Promise<any> => {
    const response = await api.patch(`/api/workflow/instances/${instanceId}/steps/${approvalId}/replace`, { new_approver_id: newApproverId, new_approver_name: newApproverName });
    return response.data;
  },

  getWorkflowTemplates: async (workflowType?: string): Promise<any> => {
    const response = await api.get('/api/workflow/templates', { params: workflowType ? { workflow_type: workflowType } : {} });
    return response.data;
  },

  getWorkflowTemplate: async (templateId: number): Promise<any> => {
    const response = await api.get(`/api/workflow/templates/${templateId}`);
    return response.data;
  },

  createWorkflowTemplate: async (data: any): Promise<any> => {
    const response = await api.post('/api/workflow/templates', data);
    return response.data;
  },

  updateWorkflowTemplate: async (templateId: number, data: any): Promise<any> => {
    const response = await api.patch(`/api/workflow/templates/${templateId}`, data);
    return response.data;
  },

  deleteWorkflowTemplate: async (templateId: number): Promise<any> => {
    const response = await api.delete(`/api/workflow/templates/${templateId}`);
    return response.data;
  },

  getApprovalCatalog: async (category?: string): Promise<any> => {
    const response = await api.get('/api/workflow/catalog', { params: category ? { category } : {} });
    return response.data;
  },

  getEligibleApprovers: async (search?: string, orgUnitId?: string): Promise<any> => {
    const response = await api.get('/api/workflow/eligible-approvers', { params: { search, org_unit_id: orgUnitId } });
    return response.data;
  },

  checkWorkflowExempt: async (workflowType: string): Promise<any> => {
    const response = await api.get('/api/workflow/check-exempt', { params: { workflow_type: workflowType } });
    return response.data;
  },

  patchWorkflowNotifications: async (instanceId: number, data: {
    cc_recipients: string | null;
    calendar_attendees: string | null;
  }): Promise<any> => {
    const response = await api.patch(`/api/workflow/instances/${instanceId}/notifications`, data);
    return response.data;
  },

  // === 즐겨찾기 (Favorites) ===
  getWorkflowFavorites: async (): Promise<any> => {
    const response = await api.get('/api/workflow/favorites');
    return response.data;
  },

  addWorkflowFavorite: async (data: {
    favorite_id: string;
    favorite_name: string;
    favorite_email?: string;
    favorite_type: string;
  }): Promise<any> => {
    const response = await api.post('/api/workflow/favorites', data);
    return response.data;
  },

  removeWorkflowFavorite: async (favoriteId: string, favoriteType: string): Promise<any> => {
    const response = await api.delete(`/api/workflow/favorites/${encodeURIComponent(favoriteId)}`, {
      params: { favorite_type: favoriteType },
    });
    return response.data;
  },

  // === 그룹 대시보드 (BACK-190) ===
  getGroupDashboard: async (): Promise<any> => {
    const response = await api.get('/api/group-dashboard');
    return response.data;
  },

  getGroupSummary: async (): Promise<any> => {
    const response = await api.get('/api/group-dashboard/summary');
    return response.data;
  },
};
